import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService) {
  }

  canActivate(): boolean {
    if (environment.production || environment.development) {
      if (!JSON.parse(localStorage.getItem('user'))?.login) {
        this.auth.login();
        return false;
      } else {
        this.auth.ping();
        return true;
      }
    } else {
      return true;
    }
  }
}
